angular
  .module('admin.directives')
  .directive('addBrokerage', addBrokerage);


function addBrokerage(){

  return {
    bindToController: {
      onSaved: '&',
      onCancel: '&'
    },
    controller: addBrokerageCtrl,
    controllerAs: 'ctrl',
    templateUrl: '/admin/templates/add-edit-brokerage.html',
    restrict: 'E',
    scope: {}
  };

};


addBrokerageCtrl.$inject = ['BrokerageService', 'HelperService'];

function addBrokerageCtrl(Service, helpers){
  var ctrl = this;

  ctrl.subject = {};
  ctrl.subject.showAddress = true;
  ctrl.subject.showNightlyRentals = true;
  ctrl.subject.showReverseMortgage = true;

  return _.merge(ctrl, {
    submit: add
  });


  /////

  function onSave(){
    ctrl.loading = false;

    if(ctrl.onSaved)
      ctrl.onSaved();
  };

  function onError(errorMsg){
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(subject){
    subject = _.cloneDeep(subject);
    subject.phone = helpers.formatPhone(subject.phone);
    return subject;
  };

  function add(){
    ctrl.loading = true;
    var subject = parseForSave(ctrl.subject);

    Service.add(subject)
      .then(onSave)
      .catch(onError);
  };

};
